var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.35 5.31c0 .6-.23 1.17-.66 1.59l-3.02 3.03-4.6-4.6 3.03-3.02c.85-.85 2.33-.86 3.18 0l1.41 1.41c.43.42.66.99.66 1.59z",
    fill: "#607d8b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.67 9.93-10.76 10.76c-.1.1-.23.17-.36.2l-4.63 1.09-.17.02c-.2 0-.39-.08-.53-.22-.18-.18-.26-.45-.2-.7l1.09-4.63c.03-.13.1-.26.2-.36l10.76-10.76z",
    fill: "#90a4ae"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.695 1.669c-.584 0-1.169.215-1.595.641l-3.03 3.02 2.321 2.321 4.615-4.615-.726-.726c-.424-.429-1.004-.641-1.585-.641z",
    fill: "#546d79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.07 5.33-10.76 10.76c-.1.1-.17.23-.2.36l-1.09 4.63c-.06.25.02.52.2.7.007.007.014.014.022.021l14.15-14.15z",
    fill: "#7d8f97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23 22h-13c-.552 0-1-.448-1-1s.448-1 1-1h13c.552 0 1 .448 1 1s-.448 1-1 1z",
    fill: "#607d8b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16.5 20h-6.5c-.552 0-1 .448-1 1s.448 1 1 1h6.5z",
    fill: "#546d79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditor);
export default __webpack_public_path__ + "static/media/editor.42bd405587573d1c4ce003773197a874.svg";
export { ForwardRef as ReactComponent };